import { createSlice } from "@reduxjs/toolkit";
import {       reKyc_send_phone_otpThunk } from "./thunk";

export const initialState = {
  reKyc_send_phone_otpData: [],
  reKyc_send_phone_otpError: '', // for error message
  reKyc_send_phone_otpLoading: false,
  
  
};

const Re_Kyc_Send_Phone_Otp = createSlice({
  name: "Re_Kyc_Send_Phone_Otp",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_send_phone_otpThunk.pending, (state) => {
      state.reKyc_send_phone_otpLoading = true ;
      state.reKyc_send_phone_otpData= [];
      state.reKyc_send_phone_otpError='';

  });
    builder.addCase(reKyc_send_phone_otpThunk.fulfilled, (state, action) => {
        state.reKyc_send_phone_otpData = action.payload.data;
        state.reKyc_send_phone_otpLoading = false ;
    });
    builder.addCase(reKyc_send_phone_otpThunk.rejected, (state, action) => {
      state.reKyc_send_phone_otpError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_send_phone_otpLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Send_Phone_Otp.actions

export default Re_Kyc_Send_Phone_Otp.reducer;